/**
 * Switching the STORE window between desktop and phone widths.
 *
 * This is the mechanism the consultant editor has used since v4.7.0: the page
 * running on the storefront resizes its OWN window (`BottomRibbon.tsx` → 375 ×
 * availHeight to go mobile, availWidth × availHeight to come back). It has to
 * be self-initiated — an opener cannot resize a cross-origin popup, and only a
 * window created by `window.open` may resize itself at all.
 *
 * Extracted here so the merchant banner overlay switches screens exactly the
 * way the editor does, instead of inventing its own dimensions. BottomRibbon
 * still has the two inline calls; it should adopt this helper next time it is
 * touched (it is in the not-yet-migrated visual-editor set).
 */

export type ViewportDevice = 'desktop' | 'mobile'

/** Phone width the editor has always used for mobile preview. */
export const MOBILE_PREVIEW_WIDTH = 375

/**
 * Resize the current window to a device's viewport. Best-effort: browsers may
 * refuse (Safari, some popup-blocker configs), so callers must confirm the
 * result by measuring rather than assuming this worked.
 */
export function resizeWindowToDevice(device: ViewportDevice): void {
  try {
    const height = window.screen.availHeight
    if (device === 'mobile') {
      window.resizeTo(MOBILE_PREVIEW_WIDTH, height)
    } else {
      window.resizeTo(window.screen.availWidth, height)
    }
  } catch {
    /* refused — the caller reports the real viewport and falls back */
  }
}
